/*
Classe de Atendente
*/
export class Atendente {
    id?: number;
    dominio?: string;
    nome?: string;
    ativo?: boolean;
    telefone?: string;
    validade?: Date;
    token?: number;
    link?: string;
    link_utilizado?: boolean;
    tempo_uso_link?: string;
    fechar_comanda?: number;

}
